class ProductCardsCarousel extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    if (!this.slider) return;

    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;

    this.initDrag();
  }

  initDrag() {
    // Desktop drag
    this.slider.addEventListener('mousedown', (e) => {
      this.isDown = true;
      this.slider.style.cursor = 'grabbing';
      this.startX = e.pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
    });

    this.slider.addEventListener('mouseleave', () => {
      this.isDown = false;
      this.slider.style.cursor = 'grab';
    });

    this.slider.addEventListener('mouseup', () => {
      this.isDown = false;
      this.slider.style.cursor = 'grab';
    });

    this.slider.addEventListener('mousemove', (e) => {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - this.startX) * 2; // Scroll speed
      this.slider.scrollLeft = this.scrollLeft - walk;
    });

    // Prevent link clicks while dragging
    let isDragging = false;
    let startMouseX = 0;
    let startMouseY = 0;
    
    this.slider.addEventListener('mousedown', (e) => {
      isDragging = false;
      startMouseX = e.pageX;
      startMouseY = e.pageY;
    });

    this.slider.addEventListener('mousemove', (e) => {
      if (this.isDown) {
        const deltaX = Math.abs(e.pageX - startMouseX);
        const deltaY = Math.abs(e.pageY - startMouseY);
        if (deltaX > 5 || deltaY > 5) {
          isDragging = true;
        }
      }
    });

    this.slider.addEventListener('click', (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
      isDragging = false;
    }, true);

    // Touch support for mobile
    let touchStartX = 0;
    let touchScrollLeft = 0;

    this.slider.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].pageX - this.slider.offsetLeft;
      touchScrollLeft = this.slider.scrollLeft;
    });

    this.slider.addEventListener('touchmove', (e) => {
      const x = e.touches[0].pageX - this.slider.offsetLeft;
      const walk = (x - touchStartX) * 2;
      this.slider.scrollLeft = touchScrollLeft - walk;
    });
  }
}

customElements.define('product-cards-carousel', ProductCardsCarousel);

